module.exports = __webpack_public_path__ + "img/map-cluster.86663418.svg";